import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const barGraphDescription: CalculatorDescription = {
  id: CalculatorId.BarGraph,
  title: 'Bar Graph Maker',
  metaTitle: 'Free Online Bar Graph Maker - Create Bar Charts Online',
  description: 'Create professional bar graphs easily with our free online tool. Perfect for comparing categories, showing rankings, or displaying survey results with horizontal bars.',
  metaDescription: 'Make custom bar charts online. Easy-to-use, free tool for creating professional bar graphs. Compare data, show trends, and visualize statistics.',
  howTo: {
    title: 'How to Create a Bar Graph',
    steps: [
      'Enter your data directly into the table or upload a CSV file',
      'Use the "Category column" control to select which column to use for categories',
      'Select one or more numeric columns using the "Value columns" control',
      'Customize your graph with options for bar layout (stacked or grouped), orientation (vertical or horizontal), title, bar width, and emphasis effects',
      'View your bar graph and download or share it as needed'
    ],
    graphic: {
      description: 'A step-by-step guide showing how to create a bar graph from data input to final visualization'
    }
  },
  examples: [
    {
      title: 'Sales Performance',
      description: 'Monthly sales performance comparing revenue and expenses',
      dataDescription: 'Time series data with two numeric variables',
      insights: [
        'Revenue shows an upward trend over the six months',
        'Expenses remain relatively stable',
        'Highest revenue peak in May',
        'Consistent profit margin maintained'
      ]
    },
    {
      title: 'Product Comparison',
      description: 'Sales volume across different product categories',
      dataDescription: 'Categorical data with single numeric variable',
      insights: [
        'Electronics category leads in sales volume',
        'Clear hierarchy in product performance',
        'Three distinct performance tiers visible',
        'Opportunity areas in lower performing categories'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.BarGraph,
    CalculatorId.StackedBarChart,
    CalculatorId.PieChart
  ]
}; 